(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.bstudioOverlayEnabled = this.dataset.bstudioOverlay === 'true';
      this.bstudioOverlayFadeBase = parseFloat(this.dataset.bstudioOverlayFade || '140') || 140;
      this.bstudioOverlayFade = this.bstudioOverlayFadeBase;
      this.bstudioOverlayStartPx = 0;
      this.bstudioOverlayStartAbs = 0;
      this.bstudioHeroTopAbs = 0;
      this.bstudioHeroBottomAbs = 0;
      this.bstudioOverlayHasHero = false;
      this.bstudioHeroResizeObserver = null;
      this.bstudioHeroRoot = null;
      this.bstudioOverlayBlurTargets = [];
      this.bstudioBlurLocked = false;
      if (this.bstudioOverlayEnabled) {
        const hero =
          document.querySelector('#MainContent slideshow-component') || document.querySelector('#MainContent .slideshow');
        this.bstudioOverlayHasHero = !!hero;
        this.bstudioHeroRoot = hero || null;
        this.bstudioHeroSection = hero ? hero.closest('.shopify-section') : null;
        if (this.bstudioOverlayHasHero) {
          document.body.classList.add('bstudio-header-overlay');
          this.bstudioHeroSection?.classList?.add?.('bstudio-hero-under-header');
          this.classList.add('bstudio-overlay-hero');

          this.collectOverlayBlurTargets();
          this.updateOverlayFadeDistance();
          if (this.bstudioHeroSection && 'ResizeObserver' in window) {
            this.bstudioHeroResizeObserver = new ResizeObserver(() => {
              this.collectOverlayBlurTargets();
              this.updateOverlayFadeDistance();
            });
            this.bstudioHeroResizeObserver.observe(this.bstudioHeroSection);
          }
        }
      }

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.updateOverlay(initialScrollTop);

      this.onPageShow = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.setHeaderHeight();
        this.updateOverlay(top);
      };
      window.addEventListener('pageshow', this.onPageShow);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updateOverlayFadeDistance() {
      if (!this.bstudioOverlayEnabled || !this.bstudioOverlayHasHero || (!this.bstudioHeroSection && !this.bstudioHeroRoot)) {
        this.bstudioOverlayFade = this.bstudioOverlayFadeBase;
        this.bstudioOverlayStartPx = 0;
        this.bstudioOverlayStartAbs = 0;
        this.bstudioHeroTopAbs = 0;
        this.bstudioHeroBottomAbs = 0;
        return;
      }

      const heroEl = this.bstudioHeroRoot || this.bstudioHeroSection;
      const rect = heroEl.getBoundingClientRect();

      // Absolute top of hero section within the document.
      const top = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.bstudioHeroTopAbs = rect.top + top;
      this.bstudioHeroBottomAbs = rect.bottom + top;

      // Fade distance is driven only by the setting (px from top of page).
      this.bstudioOverlayFade = this.bstudioOverlayFadeBase;
      this.bstudioOverlayStartPx = 0;
      this.bstudioOverlayStartAbs = 0;
    }

    collectOverlayBlurTargets() {
      const root = this.bstudioHeroRoot;
      if (!root) {
        this.bstudioOverlayBlurTargets = [];
        return;
      }

      // Target only the actual text box, not the full banner container,
      // otherwise the header would blur for the entire hero height.
      this.bstudioOverlayBlurTargets = Array.from(
        root.querySelectorAll('.slideshow__text.banner__box, .slideshow__text, .banner__box')
      ).filter((el) => (el?.textContent || '').trim().length > 0);
    }

    getOverlayBlurProgress(relScrollPx) {
      if (!this.bstudioOverlayEnabled || !this.bstudioOverlayHasHero) return 0;
      if (!this.header) return 0;

      const headerRect = this.header.getBoundingClientRect();
      const headerH = Math.max(1, headerRect.height || 0);
      const headerW = Math.max(1, headerRect.width || 0);

      // Start blurring slightly BEFORE overlap, to keep good contrast as the header approaches text.
      const proximityPx = 70;

      let maxSignal = 0;
      for (const el of this.bstudioOverlayBlurTargets) {
        if (!el || !el.getBoundingClientRect) continue;
        if (el.offsetParent === null) continue;

        const r = el.getBoundingClientRect();
        const overlapX = Math.max(0, Math.min(headerRect.right, r.right) - Math.max(headerRect.left, r.left));
        const overlapY = Math.max(0, Math.min(headerRect.bottom, r.bottom) - Math.max(headerRect.top, r.top));

        const overlapArea = overlapX * overlapY;
        const overlapRatio = overlapArea / (headerW * headerH);

        const gap = r.top - headerRect.bottom;
        const proximityRatio = gap > 0 && gap < proximityPx ? 1 - gap / proximityPx : 0;

        maxSignal = Math.max(maxSignal, overlapRatio * 1.6, proximityRatio);
        if (maxSignal >= 1) break;
      }

      // No base blur here: we want blur to start when text begins.
      return Math.min(maxSignal, 1);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onPageShow);
      if (this.bstudioHeroResizeObserver) {
        this.bstudioHeroResizeObserver.disconnect();
        this.bstudioHeroResizeObserver = null;
      }
    }

    updateOverlay(scrollTop) {
      if (!this.bstudioOverlayEnabled || !this.bstudioOverlayHasHero) return;

      const effectiveScrollTop = scrollTop < 6 ? 0 : scrollTop;
      const rel = Math.max(0, effectiveScrollTop - (this.bstudioHeroTopAbs || 0));
      const fade = this.bstudioOverlayFade || this.bstudioOverlayFadeBase || 140;
      // Setting controls how many px from the top to become solid.
      const progressRaw = Math.max(0, Math.min(effectiveScrollTop / fade, 1));
      // Smootherstep easing (even softer than smoothstep): 6t^5 - 15t^4 + 10t^3.
      const t = progressRaw;
      const smoother = t * t * t * (t * (t * 6 - 15) + 10);
      // Bias toward transparency at the beginning to avoid any "white bar" feel.
      const progress = Math.pow(smoother, 1.8);

      this.style.setProperty('--bstudio-overlay-progress', progress.toFixed(3));

      // Desired behavior:
      // - at very top: transparent, white logo/text, NO blur
      // - when slideshow text starts: small blur (setting default is 6px) and keep it until end
      // - at the end: header becomes solid and switches to default (black) logo/text
      // Use absolute scroll position for "top" detection.
      // `rel` can be non-zero at scrollTop 0 due to the hero being pulled under the header.
      const atTop = effectiveScrollTop <= 12;
      if (atTop || progress >= 1) this.bstudioBlurLocked = false;

      const blurSignal = this.getOverlayBlurProgress(rel);
      if (!atTop && progress < 1 && (this.bstudioBlurLocked || blurSignal >= 0.28)) {
        this.bstudioBlurLocked = true;
      }

      const blurProgress = atTop ? 0 : this.bstudioBlurLocked ? 1 : Math.max(0, Math.min(blurSignal * 1.2, 1));
      this.style.setProperty('--bstudio-overlay-blur-progress', blurProgress.toFixed(3));

      // Keep overlay state deterministic to avoid "stuck" visual states
      // when scrolling quickly back to the top.
      this.classList.toggle('bstudio-overlay-top', atTop);
      this.classList.toggle('bstudio-overlay-hero', progress < 0.999);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateOverlay(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
